import {TabTypeDto} from '../types'

export const SLA_KPI_MIN_YEAR = '2024'

export const SLA_TABLE_WIDTHS = {
  DATA_FIELD: 250,
  TARGET: 200,
  MONTHS: 140
}

export const SLA_TABLE_LEFTS = {
  DATA_FIELD: 0,
  TARGET: SLA_TABLE_WIDTHS.DATA_FIELD
}

export const SLA_TABLE_COLUMNS = {
  DATA_FIELD: 'dataField',
  TARGET: 'target',
  JANUARY: 'january',
  FEBRUARY: 'february',
  MARCH: 'march',
  APRIL: 'april',
  MAY: 'may',
  JUNE: 'june',
  JULY: 'july',
  AUGUST: 'august',
  SEPTEMBER: 'september',
  OCTOBER: 'october',
  NOVEMBER: 'november',
  DECEMBER: 'december'
} as const

const NONE_MONTHS_LEADING_COLUMNS_COUNT = 2
export const SLA_TABLE_COLUMN_KEYS = Object.values(SLA_TABLE_COLUMNS)

export const SLA_TABLE_COLUMN_KEYS_TO_MONTH = SLA_TABLE_COLUMN_KEYS.slice(
  NONE_MONTHS_LEADING_COLUMNS_COUNT
).reduce(
  (acc, key, index) => {
    acc[key] = index + 1
    return acc
  },
  {} as Record<string, number>
)

export const TAB_TYPE_SORT_ORDER_MAP: Record<TabTypeDto, number> = {
  [TabTypeDto.ProcessEngineer]: 1,
  [TabTypeDto.QualityEngineer]: 2,
  [TabTypeDto.ReliabilityEngineer]: 3,
  [TabTypeDto.SystemsEngineer]: 4,
  [TabTypeDto.OutagePlanning]: 5,
  [TabTypeDto.OptimizationSpecialist]: 6
}
